var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { Service } from '~/core/service';
import { FilterService } from "~/utils/filter.service";
var CaseVerifyService = /** @class */ (function (_super) {
    __extends(CaseVerifyService, _super);
    function CaseVerifyService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询核销案信息
     * @param 查询条件
     * @page 页码信息
     */
    CaseVerifyService.prototype.getAllVerifyInfos = function (data, page) {
        return this.netService.send({
            server: domainService.caseVerifyController.getAllVerifyInfos,
            data: __assign(__assign({}, data), {
                overdueAmountMax: data.overdueAmount.max,
                overdueAmountMin: data.overdueAmount.min,
                overdueDaysMax: data.overdueDays.max,
                overdueDaysMin: data.overdueDays.min,
                followInTimeMax: FilterService.dateRanageFormat(data.followInTime).end,
                followInTimeMin: FilterService.dateRanageFormat(data.followInTime).start,
                labelName: data.labelName,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : ''
            }),
            page: page
        });
    };
    /**
     * 核销案件
     * @param data
     */
    CaseVerifyService.prototype.verifiedCaseInfo = function (data) {
        return this.netService.send({
            server: domainService.caseVerifyController.verifiedCaseInfo,
            data: data
        });
    };
    /**
     * 附件上传
     * @param data
     */
    CaseVerifyService.prototype.uploadCaseVerifyFile = function (data) {
        return this.netService.send({
            server: domainService.caseVerifyController.uploadCaseVerifyFile,
            data: data
        });
    };
    /**
     * 附件上传
     * @param data
     */
    CaseVerifyService.prototype.exportVerifyInfos = function (data) {
        return this.netService.send({
            server: domainService.caseVerifyController.exportVerifyInfos,
            data: __assign(__assign({}, data), {
                overdueAmountMax: data.overdueAmount.max,
                overdueAmountMin: data.overdueAmount.min,
                overdueDaysMax: data.overdueDays.max,
                overdueDaysMin: data.overdueDays.min
            })
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseVerifyService.prototype, "netService", void 0);
    return CaseVerifyService;
}(Service));
export { CaseVerifyService };
